import { useState } from "react";

const useTiltEffect = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });

  const handleMouseMove = (e) => {

    const { clientX, clientY } = e;

    // Рассчитываем вращение по осям
    // const rotateX = ((clientX - window.innerHeight / 2) / (window.innerHeight / 2)) * -5;
    // const rotateY = ((clientY - window.innerWidth / 2) / ( window.innerWidth / 2)) * -5;

    setPosition({ x: clientX, y: clientY });
    // console.log({ x: rotateY, y: rotateX });
  };

  const resetPosition = () => {
    setPosition({ x: 0, y: 0 });
  };

  return { position, handleMouseMove, resetPosition };
};

export default useTiltEffect;
